import { render, staticRenderFns } from "./fileDetail.vue?vue&type=template&id=7755b638&scoped=true&"
import script from "./fileDetail.vue?vue&type=script&lang=js&"
export * from "./fileDetail.vue?vue&type=script&lang=js&"
import style0 from "./fileDetail.vue?vue&type=style&index=0&id=7755b638&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7755b638",
  null
  
)

export default component.exports